import React, { useMemo } from 'react';
import SubPage from '#/common/components/SubPage';
import WOTemplateForm from '../components/WOTemplateForm';
import useWOTemplateCreate from '../hooks/useWOTemplateCreate';
import type { WorkOrderTemplate } from '#/graphql/types';
import { createFields } from '../components/WOTemplateForm/fields';
import { SubmitWorkOrderTemplate } from '../utils/types';

const NewWOTemplatesPage: React.FC = () => {
  const title = 'New WO Template';
  const newWOTemplate = useMemo(() => {
    return {
      number: Math.floor(Math.random() * 10000),
    } as WorkOrderTemplate;
  }, []);

  const { createWOTemplate } = useWOTemplateCreate();

  return (
    <SubPage title={title} showGoBackButton type="form">
      <WOTemplateForm
        title={title}
        woTemplate={newWOTemplate}
        fields={createFields}
        submit={createWOTemplate}
      />
    </SubPage>
  );
};

export default React.memo(NewWOTemplatesPage);
